// /careers/$sphere — sphere page (RU). Unknown slug → 404.
import { createFileRoute, notFound } from "@tanstack/react-router";
import { SpherePage } from "@/careers/SpherePage";
import { careersHead, BASE_URL } from "@/careers/head";
import { sphereJsonLd } from "@/careers/careerPages";
import { UI, SPHERE_SLUGS, sphereDescription } from "@/careers/spheres";
import { buildSphere } from "@/careers/data";

export const Route = createFileRoute("/careers/$sphere")({
  loader: ({ params }) => {
    if (!SPHERE_SLUGS.includes(params.sphere)) throw notFound();
  },
  head: ({ params }) => {
    const slug = params.sphere;
    const data = buildSphere(slug, "ru");
    if (!data) return {};
    const alt = {
      az: `/az/careers/${slug}`,
      ru: `/careers/${slug}`,
      en: `/en/careers/${slug}`,
    };
    const title = `${data.name} · ${UI.ru.breadcrumbRoot} — Yolutap`;
    const description = sphereDescription("ru", data.name, data.count, data.subtitle);
    const jsonLd = sphereJsonLd({
      sphereName: data.name,
      baseUrl: BASE_URL,
      rootPath: `/careers`,
      spherePath: `/careers/${slug}`,
      breadcrumbRoot: UI.ru.breadcrumbRoot,
    });
    return careersHead({ lang: "ru", canonicalPath: `/careers/${slug}`, altPaths: alt, title, description, jsonLd });
  },
  component: () => {
    const { sphere } = Route.useParams();
    return <SpherePage lang="ru" slug={sphere} />;
  },
});
